// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '../utils/helpers';

// IIFE wrapper pattern
const IIFE_START = '(function () {';
const IIFE_END = '})();';

/**
 * Get JavaScript content from script tag, extracting only the inner content of the IIFE
 */
const getJavascriptContent = (selector: string): string => {
  const template = getTemplateIframeDocument();
  const scriptElement: HTMLScriptElement | null = template?.querySelector(selector);

  if (scriptElement) {
    const fullContent = scriptElement.textContent || '';

    // Extract content between IIFE wrapper
    const startIndex = fullContent.indexOf(IIFE_START);
    const endIndex = fullContent.lastIndexOf(IIFE_END);

    if (startIndex !== -1 && endIndex !== -1) {
      const innerContent = fullContent.substring(
        startIndex + IIFE_START.length,
        endIndex,
      );
      return innerContent.trim();
    }

    return fullContent.trim();
  }
  return '';
};

export default getJavascriptContent;
